import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex w-full items-center justify-center px-4 py-20 md:px-6 md:py-28">
      <div className="w-full max-w-lg rounded-xl border border-background-200/70 bg-background-100 p-10 text-center">
        <span className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-primary-500/12 text-primary-500">
          <i className="ri-live-line text-3xl"></i>
        </span>
        <p className="mt-6 font-heading text-4xl font-bold text-foreground-950">404</p>
        <h1 className="mt-4 font-heading text-lg font-semibold text-foreground-950">你访问的页面不存在</h1>
        <p className="mt-2 text-sm leading-relaxed text-foreground-400">
          该链接可能已失效，或者页面正在准备中。欢迎返回首页继续观看精彩直播。
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/search"
            className="rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-500 whitespace-nowrap"
          >
            搜索直播
          </Link>
        </div>
      </div>
    </div>
  );
}